import { ModuleRoute } from 'module-routes';

export enum SalePath {
  NewSale = 'new-sale',
  SaleList = 'sale-list',
  CreditSale = 'credit-sale',
  CreditSalePayment = 'credit-sale-payment',
}

export const SaleModuleRoutes = new Map<SalePath, <T>(id?: T) => string>([
  [SalePath.NewSale, () => `${ModuleRoute.Sale}/${SalePath.NewSale}`],
  [SalePath.SaleList, () => `${ModuleRoute.Sale}/${SalePath.SaleList}`],
  [SalePath.CreditSale, () => `${ModuleRoute.Sale}/${SalePath.CreditSale}`],
  [SalePath.CreditSalePayment, () => `${ModuleRoute.Sale}/${SalePath.CreditSalePayment}`],
]);

export const getSaleModuleRoutes = <T>(route: SalePath, id?: T): string => {
  const routeFunction = SaleModuleRoutes.get(route);
  if (routeFunction) {
    return routeFunction(id);
  }
  throw new Error(`Route ${route} not found}`);
};
